export const Types = {
  // a Módulos
  GET_REQUEST: 'module/GET_REQUEST',
  GET_SUCCESS: 'module/GET_SUCCESS',
  GET_FAILURE: 'module/GET_FAILURE',
  GET_GROUPS_REQUEST: 'module/GET_GROUPS_REQUEST',
  GET_GROUPS_SUCCESS: 'module/GET_GROUPS_SUCCESS',
  // reseta a de Módulos
  RESET: 'module/RESET',
};

export const initialState = {
  // a de Módulos
  module: [],
  groups: [],
  moduleLoading: false,
  moduleError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // a de Módulos
    case Types.GET_REQUEST:
      return { ...state, modulesLoading: true };
    case Types.GET_SUCCESS:
      return {
        ...state,
        module: action.payload.data,
        moduleLoading: false,
        moduleError: null,
      };
    case Types.GET_GROUPS_SUCCESS:
      return {
        ...state,
        groups: action.payload.data,
        moduleLoading: false,
        moduleError: null,
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        modulesLoading: false,
        modulesError: action.payload,
      };
    case Types.RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export const Creators = {
  // Busca lista de Módulo
  getModuleRequest: (id) => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),
  getModuleSuccess: ({ data, total }) => ({
    type: Types.GET_SUCCESS,
    payload: { data, total },
  }),
  getModuleFailure: (error) => ({
    type: Types.GET_FAILURE,
    payload: error,
  }),
  reset: () => ({
    type: Types.RESET,
  }),
  getGroups: () => ({
    type: Types.GET_GROUPS_REQUEST,
  }),
  getGroupsSuccess: ({ data }) => ({
    type: Types.GET_GROUPS_SUCCESS,
    payload: { data },
  }),
};
